{
    "Accessibility Menu": "Saavutettavuusvalikko",
    "Reset settings": "Palauta asetukset",
    "Close": "Sulje",
    "Content Adjustments": "Sisällön säädöt",
    "Adjust Font Size": "Säädä fonttikokoa",
    "Highlight Title": "Korosta otsikko",
    "Highlight Links": "Korosta linkit",
    "Readable Font": "Helposti luettava fontti",
    "Color Adjustments": "Värien säädöt",
    "Dark Contrast": "Tumma kontrasti",
    "Light Contrast": "Vaalea kontrasti",
    "High Contrast": "Korkea kontrasti",
    "High Saturation": "Korkea kylläisyys",
    "Low Saturation": "Matala kylläisyys",
    "Monochrome": "Yksivärinen",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Visuaaliset ja navigointiapuvälineet",
    "Additional Tools": "Lisätyökalut",
    "Reading Guide": "Lukemisopas",
    "Stop Animations": "Pysäytä animaatiot",
    "Big Cursor": "Iso kohdistin",
    "Screen Reader": "Ruudunlukija",
    "Hide Images": "Piilota kuvat",
    "Image Tooltips": "Kuvavihjeet",
    "Page Structure": "Sivurakenne",
    "Super Focus": "Superfokus",
    "Magnifier": "Suurennuslasi",
    "Increase Font Size": "Suurenna fonttikokoa",
    "Decrease Font Size": "Pienennä fonttikokoa",
    "Letter Spacing": "Kirjainten välistys",
    "Line Height": "Rivin korkeus",
    "Font Weight": "Fontin paksuus",
    "Dyslexia Font": "Dysleksiafontti",
    "Language": "Kieli",
    "Open Accessibility Menu": "Avaa saavutettavuusvalikko",
    "Accessibility Profiles": "Saavutettavuusprofiilit",
    "Seizure Safe Profile": "Kohtausturvallinen profiili",
    "Stops animations and reduces color saturation.": "Pysäyttää animaatiot ja vähentää värikylläisyyttä.",
    "Blind Profile": "Sokeiden profiili",
    "Activates the screen reader for auditory navigation.": "Aktivoi ruudunlukijan ääninagivointia varten.",
    "Visually Impaired Profile": "Heikkonäköisten profiili",
    "Enhances contrast and readability for low vision.": "Parantaa kontrastia ja luettavuutta heikkonäköisille.",
    "ADHD Friendly Profile": "ADHD-ystävällinen profiili",
    "Reduces distractions for better focus.": "Vähentää häiriötekijöitä paremman keskittymisen vuoksi.",
    "Cognitive & Learning Profile": "Kognitiivinen ja oppimisprofiili",
    "Helpful tools for reading and comprehension.": "Hyödyllisiä työkaluja lukemiseen ja ymmärtämiseen.",
    "Motor Impaired Profile": "Motorisesti vammaisten profiili",
    "Optimizes the site for keyboard-only navigation.": "Optimoi sivuston pelkällä näppäimistöllä navigointiin.",
    "Headings": "Otsikot",
    "Landmarks": "Maamerkit",
    "Links": "Linkit",
    "Focus element": "Kohdista elementti",
    "Visit link": "Vieraile linkissä"
}
